import { FC } from 'react';

import { FINAL_STATUSES } from '@/features/transactions-modal/config';

import { AvatarWithIndicator } from '@/shared/ui';

import { getTransactionAvatar } from '../lib/helpers';
import { ITransaction } from '../model/types';

export const TxsItemAvatar: FC<{ transaction: ITransaction }> = ({
  transaction,
}) => {
  if (!transaction) return null;
  const { avatar, defaultAvatar } = getTransactionAvatar(transaction);
  return (
    <AvatarWithIndicator
      className="pr-4"
      showIndicator={!FINAL_STATUSES.includes(transaction.status)}
      avatar={avatar}
      defaultAvatar={defaultAvatar}
    />
  );
};
